import styled from '@emotion/styled'

export const Divider = styled.div`
  height: 1px;
  background: var(--c-border);
  width: 100%;
`
